// navigation JS
var navToggleIcon = document.querySelector('.nav-toggle');

// nav open/close toggle
function navToggle() {
	let search = document.querySelector('.nav-search > form'),
		icontext = document.querySelector('.nav-toggle-text').innerText,
		home = document.querySelector('.banner-frontpage') ? true : false,
		nav = document.querySelector('.navigation-container-top');

	if (icontext === 'Menu') {
		//window.innerWidth > 640 ? jQuery('#toggle-nav-search').fadeIn(300): '';
		jQuery('.navigation-container-bottom').slideDown(300);
		jQuery('.nav-toggle-text').text('Close');
		jQuery('.nav-toggle').toggleClass('open');
		home && window.pageYOffset < 50 ? nav.classList.remove('transparent-bg') : '';
	} else {
		//window.innerWidth > 640 ? jQuery('#toggle-nav-search').delay(300).fadeOut(0): '';
		jQuery('.navigation-container-bottom').slideUp(300);
		jQuery('.nav-toggle-text').text('Menu');
		jQuery('.nav-toggle').toggleClass('open');
		setTimeout(function(){
			home && window.pageYOffset < 50 ? nav.classList.add('transparent-bg') : '';
		}, 300);
	}

	// clear search input
	search.elements[0].value = '';
}

// change nav background color
function navScrollFrontpage() {
	let nav = document.querySelector('.navigation-container-top');

	window.addEventListener('scroll', function(e) {
		let navLinksClosed = document.querySelector('.navigation-container-bottom').style.display === 'none' ? true : false;
		if ( navLinksClosed ) {
			if ( window.pageYOffset < 50 ) {
				nav.classList.add('transparent-bg');
				nav.classList.remove('box-shadow');
			} else {
				nav.classList.remove('transparent-bg'); 
				nav.classList.add('box-shadow');
			}
		}
	});
}

jQuery(document).ready(function($) {
	$( function( container ) {
		var dropdownTouch,
			parentLink = $( '#primary-menu>.menu-item-has-children>a' );
		if ( 'ontouchstart' in window ) {
			dropdownTouch = function( e ) {
				var menuItem = $( this ).parent();
				if ( ! menuItem.hasClass( 'focus' ) ) {
					e.preventDefault();
					var links = menuItem.parent().children();
					for (let i = 0; i < links.length; i++) {
						if ( menuItem === menuItem.parent().children( i ) ) {
							return false;
						}
						if(window.innerWidth <= 999){
							$('#primary-menu>.menu-item-has-children>.sub-menu').slideUp(300);
						}
						
						$( links[i] ).removeClass( 'focus' );
					}
					menuItem.addClass( 'focus' );
					if(window.innerWidth <= 999){
						$( this ).next().slideDown(300);
					}
				}
			};

			for (let i = 0; i < parentLink.length; i++) {
				parentLink[i].addEventListener( 'touchstart', dropdownTouch, true );
			}
		} else {
			jQuery( '#primary-menu>.menu-item-has-children' ).hover(
				function() {
					jQuery( this ).addClass( 'submenu-opened' );
					jQuery( this ).find( '.sub-menu' );
				},
				function() {
					jQuery( this ).removeClass( 'submenu-opened' );
					jQuery( this ).find( '.sub-menu' );
				}
			);
		}
	}( 'body' ) );

	$('#toggle-nav-search>form').on('submit', function(e){
		if( $(this).hasClass('active') ){
			var s = $(this).find('input[type=search]').val();
			if( s !== '' ){
				$(this).submit();
			} else {
				e.preventDefault();
			}
		} else {
			e.preventDefault();
			$(this).addClass('active');
		}
	});

	$(window).on( 'scroll', function () {
		if (30 < $(window).scrollTop()) {
			$(".nav-parent-container").addClass("onscroll");
		} else {
			$(".nav-parent-container").removeClass("onscroll");
		}
	});
});


// listen on nav toggle click
navToggleIcon.addEventListener('click', function(e){
	navToggle();
});

// listen for toggle nav background color on frontpage
window.addEventListener('load', function(e){
	document.querySelector('.banner-frontpage') ? navScrollFrontpage() : '';
});
